import type { RootState } from "../store"

export const coveragePayersSelector = (state: RootState) =>
    state.coveragePayers.items
